import * as yup from 'yup'
import { IntlShape } from 'react-intl'

import { itinerariesSchema } from 'features/Services/components/NewServicesV2/components/ItinerariesCard/schema'
import { isDate } from 'date-fns'

export const servicesFormSchema = (intl: IntlShape): yup.SchemaOf<TSFixMe> => {
  return yup.object().shape({
    services: yup.array().of(
      yup
        .object()
        .shape({
          endDate: yup.date().nullable().optional(),
          itineraries: yup.array().when('endDate', {
            is: (endDate?: Date | null) => isDate(endDate),
            then: itinerariesSchema(intl, { isEndDateOptional: false }).fields.itineraries,
            otherwise: itinerariesSchema(intl, { isEndDateOptional: true }).fields.itineraries
          })
        })
        .required()
    )
  })
}
